/**
 * Experience section on the home page.
 * In `points`, wrap words in **double asterisks** to make them bold.
 */
export const EXPERIENCE_ITEMS = [
  {
    company: "Care Health Insurance Limited",
    period: "May 2024 – Present",
    points: [
      "**Faveo Plus Ecosystem:** spearheaded a UX overhaul by auditing **15+ internal workflows** to resolve usability friction for insurance agents.",
      "**Organic Growth Tools:** conceptualized and shipped scalable SEO templates and **10+ static pages**, including BMI and Pregnancy calculators and the E-Power agent website.",
      "**Customer App Redesign:** directed a comprehensive redesign, overseeing end-to-end UI/UX across **10+ modules** to improve the digital policyholder experience.",
      "**User Journey Optimization:** utilized funnel analysis to streamline complex insurance processes and improve user retention within the mobile application.",
    ],
  },
];
